import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-blog-tag',
  templateUrl: './blog-tag.component.html',
  styleUrls: ['./blog-tag.component.scss']
})
export class BlogTagComponent implements OnInit {
  tag: string | null = null;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.tag = this.route.snapshot.paramMap.get('tag');
    // TODO: filter entries by tag
  }
}
